import { EnvironmentInterface, EnvironmentStatus } from "./interfaces/environment";

const getEnvSelected = (): EnvironmentInterface => {
    let status = EnvironmentStatus.production;
    const org = window.location.origin;
    let googleAnalyticsId: string = "G-ZNSYVD5200";

    let description =
        "ذخیره‌سازی فایل‌ها در ابر همراهی. با ابرهمراهی فایل‌های خود را ذخیره کرده و با دوستان خود به اشتراک بگذارید. بهترین جایگزین فضای ذخیره‌سازی با سرعت بالا";
    status = EnvironmentStatus.production; // DEAR DEVELOPER, PLEASE DO NOT CHANGE THIS !!!!!

    return {
        status: status,
        uploadCenter: "https://abrehamrahi.ir/upload",
        baseUrl: () => "https://abrehamrahi.ir/api",
        reduxDevTool: !(org.includes("abrehamrahi.ir") || org.includes("hamrahi.cloud")),
        landingBaseUrl: "https://abrehamrahi.ir/",
        feedbackLogUrl: "https://abrehamrahi.ir/drive-feedback.log",
        brandName: "ابرهمراهی",
        googleAnalyticsId: googleAnalyticsId,
        hotJarId: 3490554,
        metaDescription: description,
        taxPercent: 10,
        linkMaxCount: 10,
        android: "android",
        country: "IR",
        prefix: "+98"
    };
};

export const ENVIRONMENT: EnvironmentInterface = getEnvSelected();
